import { BuilderDocument } from '../builderDocument';
import { BuilderDocumentFormat } from '../builderDocumentFormat';

export class BuilderVideoDocument extends BuilderDocument {
    public format = BuilderDocumentFormat.video;
}
